module.exports = __webpack_public_path__ + "static/media/saved-searches-empty-state-m.607dacc2.svg";